export const filterLoansByUserEmail = (loans = [], userEmail) => {
  if (!userEmail) return loans;
  const filtered = loans?.filter(
    (l) =>
      l?.salesperson === userEmail ||
      l?.loanCloser === userEmail ||
      l?.processor === userEmail ||
      l?.underwriter === userEmail ||
      l?.permittedUsers?.includes(userEmail)
  );
  return filtered;
};
